import reduxApi from 'redux-api';
import customFetch from 'api/axios';
import CONFIG from 'base/constants/config';

const limit = 20;

// Example
const rest = reduxApi({
  signin: {
    url: `/users/login`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: {},
      };
    }
  },
  signinToBusinessOwner: {
    url: `/users/loginToBusinessOwner`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: {},
      };
    }
  },
  signout: {
    url: `/users/logout`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: {},
      };
    }
  },
  loginWithFacebook: {
    url: `/users/login-facebook`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: {},
      };
    }
  },
  me: {
    url: 'users/me',
    options: {
      method: "GET"
    }
  },
  signinWithTicket: {
    url: `/users/signinWithTicket/:id`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: {},
      };
    }
  },
})
.use('fetch', customFetch)
.use("rootUrl", CONFIG.API_VITRADE_URL);

export default rest;



// WEBPACK FOOTER //
// ./api/auth.js